import React, { useState } from "react"
import i18n from "lib/i18n"
import ContactAuthorForm, { type ContactReason } from "components/Profile/ContactAuthor/Form"
import { sidebarPrimaryButton } from "components/Profile/ContactAuthor/buttonClasses"

export type { ContactReason }

interface ContactAuthorProps {
  authorId: number | string
  availableFor: ContactReason[]
}

// A user profiles sidebar's Contact button, which opens the contact form dialog
export default function ContactAuthor({ authorId, availableFor }: ContactAuthorProps) {
  "use memo"

  const [formOpen, setFormOpen] = useState(false)

  return (
    <>
      <button
        type="button"
        data-testid="contact-author"
        className={sidebarPrimaryButton}
        onClick={() => setFormOpen(true)}
      >
        {i18n.t("author_communication.button.contact")}
      </button>
      {formOpen ? (
        <ContactAuthorForm
          authorId={authorId}
          availableFor={availableFor}
          onClose={() => setFormOpen(false)}
        />
      ) : null}
    </>
  )
}
